import users from "../../../../shared/src/data/users.json";
export const userOnVacations: { title: string; color: string }[] = [];

export const AUTH_STORAGE = "mc-auth-storage";

export const authStorageInitialState = {
  user: undefined,
  meId: undefined,
  isLoggedIn: false,
  token: undefined
};

export const getRequestUserId = (id: string) => {
  const user = users.find((u) => u.redmineUserId.toString() === id);
  if (!user) {
    return id;
  }
  return user?.requestUserId?.toString();
};
